import React from 'react'
import PropTypes from 'prop-types'

import UserAware from 'components/UserAware'
import { Route, Redirect } from 'react-router-dom'
import Module from '@scoir/components-core/dist/components/Module'
import Stage from '@scoir/components-core/dist/components/Stage'
import { NavigationWrapper } from '@scoir/messaging'

import Messages from '../Messages'
import Notifications from '../Notifications'

import './index.scss'

class MessageCenter extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      path: PropTypes.string,
    }),
  }
  render() {
    const { path } = this.props.match
    const links = [
      {
        path: `${path}/messages`,
        label: 'Direct Messages',
      },
      {
        path: `${path}/notifications`,
        label: 'Notifications',
      },
    ]
    return (
      <Stage
        maxSize="unlimited"
        className="route-message-center"
      >
        <h2>Message Center</h2>
        <Module contentPadding="none">
          <NavigationWrapper links={links}>
            <div className="mc-body">
              <Route
                exact
                path={`${path}/messages`}
                render={(props) => (
                  <UserAware
                    render={(user) => (
                      <Messages
                        userId={user.Id}
                        {...props}
                      />
                    )}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/notifications`}
                component={Notifications}
              />
              <Redirect to={links[0].path} />
            </div>
          </NavigationWrapper>
        </Module>
      </Stage>
    )
  }
}

export default MessageCenter
